/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import { slug } from '../../common';
import Application from 'flarum/common/Application';

// CORE_CODE_OVERRIDE
export default function () {
	// `requestErrorCatch` is protected; there is no public extension point for this.
	// @ts-expect-error
	override<Application, 'requestErrorCatch'>(app, 'requestErrorCatch', function (original, error, customErrorHandler) {
		if (error.status === 422) {
			let customErrIndex: number | undefined;
			const errCode = error.response?.errors
				?.map((err, i) => {
					switch (err.detail) {
						case `${slug}:article_not_found`:
						case `${slug}:review_locked`:
						case `${slug}:review_permission`:
							customErrIndex = i;
							return err.detail;
						default:
							return false;
					}
				})
				.filter((err) => err)
				.shift();

			if (errCode) {
				// A truthy `errCode` means the branch above set `customErrIndex`.
				error.response!.errors!.splice(customErrIndex!, 1);

				error.gb_internal_code = errCode;
			}
		}

		return original(error, customErrorHandler);
	});
}
